import {ProgramType, AutoChargeConfiguration, EnhancedRentTransactions} from 'src/app/custom/housing-core/services/housing-models';
import {AutoChargeConfigurationValues, FeeTableValue, ProgramFeeTable, ProgramModel, ProgramSettings} from './program.model';
import {AccountActivityRule, AccountDefinition, DefaultTerms, ImportKey} from 'src/app/custom/accounting/service/accounting-models';
import {ProjectFeeTable} from './project.model';

export class ProjectFeeTableObject implements ProjectFeeTable {
  id: string;
  projectOverridesId: string;
  effectiveDate: Date;
  feeTableType: string;
  feeTableValues: FeeTableValue[];
  status?: number | undefined;
  constructor(feetableType: string) {
    this.id = null;
    this.projectOverridesId = null;
    this.effectiveDate = new Date();
    this.feeTableType = feetableType;
    this.feeTableValues = [
      new FeeTableValueObject(0),
      new FeeTableValueObject(1),
      new FeeTableValueObject(2),
      new FeeTableValueObject(3),
      new FeeTableValueObject(4),
      new FeeTableValueObject(5),
      new FeeTableValueObject(6),
      new FeeTableValueObject(7),
      new FeeTableValueObject(8),
      new FeeTableValueObject(9),
      new FeeTableValueObject(10),
    ];
    this.status = ProjectFeeStatus.Create;
  }
}

export enum ProjectFeeStatus {
  Create = 0,
  CreateAndModified,
  Modified,
  Delete,
}

export class FeeTableValueObject implements FeeTableValue {
  id: string;
  feeTableId: string;
  householdSize: number;
  amount: number;
  constructor(houseHoldSize: number) {
    this.id = null;
    this.feeTableId = null;
    this.householdSize = houseHoldSize;
    this.amount = 0;
  }
}
